import { SITE_ORIGIN } from '@/navigation/constants'

export const DEFAULT_SHARE_IMAGE = `${SITE_ORIGIN}/escandallo-restaurante.webp`
export const TIPI_LOGO_IMAGE = `${SITE_ORIGIN}/food-cost/tipi-logo-orange-header.webp`

export function tipiPublisherJsonLd() {
    return {
        '@type': 'Organization' as const,
        name: 'Tipi',
        url: SITE_ORIGIN,
        logo: {
            '@type': 'ImageObject' as const,
            url: TIPI_LOGO_IMAGE,
        },
    }
}

export function articleBreadcrumbListJsonLd(items: { name: string; url: string }[]) {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url,
        })),
    }
}
